import React, { createContext, useContext, useState, useEffect } from 'react';

const TOKEN_KEY = 'accessToken';
const ROLES_KEY = 'userRoles';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [jwtToken, setJwtToken] = useState('');
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    const storedToken = sessionStorage.getItem(TOKEN_KEY);
    let storedRoles = [];
    try {
      storedRoles = JSON.parse(sessionStorage.getItem(ROLES_KEY)) || [];
    } catch {
      sessionStorage.removeItem(ROLES_KEY);
    }
    if (storedToken) setJwtToken(storedToken);
    if (storedRoles.length) setUserRoles(storedRoles);
  }, []);

  const login = (token, roles) => {
    const safeRoles = roles || [];
    setJwtToken(token);
    setUserRoles(safeRoles);
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(ROLES_KEY, JSON.stringify(safeRoles));
  };

  const logout = () => {
    setJwtToken('');
    setUserRoles([]);
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(ROLES_KEY);
  };

  return (
    <AuthContext.Provider value={{ jwtToken, userRoles, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve essere utilizzato all'interno di un AuthProvider");
  }
  return context;
};
